import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PublicationHelper } from '../../helpers/publication.helper';
import { CreatePublicationCommand } from '../../models/clubs/create-publication.command';
import { Publication } from '../../models/clubs/publication.model';

@Injectable({
    providedIn: 'root',
})
export class CommentApiService {
    private readonly commentApiUrl = `${environment.microservices.clubs.baseUrl}/${environment.microservices.clubs.commentApi.baseUrl}`;

    constructor(private http: HttpClient) {}

    public createComment(command: CreatePublicationCommand): Observable<Publication> {
        const formData: FormData = PublicationHelper.getFormData(command);
        return this.http.post<Publication>(this.commentApiUrl, formData);
    }
}
